export default __webpack_public_path__ + "static/media/carlLoryIndoor2.7e5fe6c2.png";